<template>
  <fragment>
    <search-nav-year-month label="대상년도" v-model="nav.yearMonth" type="year" :use-all-year="true"/>
    <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.stype" :list="searchTypes" name="stype" />
    <search-nav-item-keyword :label="$t('search.키워드')" v-model="nav.searchKeyword" />
  </fragment>
</template>

<script>
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
import SearchNav from "@/components/nav/SearchNav";
import SearchNavItemKeyword from "@/components/nav/SearchNavItemKeyword";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavYearMonth from "@/components/nav/SearchNavYearMonth.vue";
import moment from "moment";

export default {
  name: "NormalSearchNav365",
  components: {
    SearchNavYearMonth,
    SearchNavStartEnd,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    SearchNav,
  },
  watch: {
    nav: {
      immediate: true,
      deep: true,
      handler(value) {

        const year = value.yearMonth.year;
        const month = value.yearMonth.month;
        if (!year) {
          value.created_at.sDate = '';
          value.created_at.eDate = '';
        } else if (!month) {
          value.created_at.sDate = `${year}-01-01`;
          value.created_at.eDate = `${year}-12-31`;
        } else if (year && month) {
          value.created_at.sDate = `${year}-${month}-01`;
          value.created_at.eDate = `${year}-${month}-${new Date(year, Number(month), 0).getDate()}`;
        }

        this.$emit("input", this.nav);
      },
    },
  },
  data() {
    return {
      nav: {
        yearMonth: {year:'', month: ''},
        created_at: {sDate: '', eDate: ''},
        stype: "", //searchType 을 사용했으나, year, month 에 searchType의 데이터가 들어가는 버그가 있어서 stype으로 변경
        searchKeyword: "",
      },
      searchTypes: [{ value: "사업장명" }, { value: "소속명" }, { value: "부서명" }, { value: "작성자" }],
    };
  },
};
</script>

<style scoped></style>
